import React from 'react';
import { isEmailConnected } from '../../utils/emailConnected';
import { useCurrentUser } from '../../contexts/CurrentUserContext';
import { useMorningBriefing } from '../../hooks/useMorningBriefing';
import BriefingCard from './BriefingCard';

export default function MorningBriefing({ tasks = [], googleEvents = [], icalEvents = [], outlookEvents = [] }) {
  const { currentUser } = useCurrentUser();

  const { briefing, loading, resendEmail, shouldShow, mode, briefingTime } =
    useMorningBriefing({ tasks, googleEvents, icalEvents, outlookEvents });

  if (!shouldShow) return null;

  // emailConnections is an ARRAY of rows, so `.gmail?.connected` was undefined and
  // this was always false. See utils/emailConnected.
  const emailConnected = isEmailConnected(currentUser);

  return (
    <BriefingCard
      briefing={briefing}
      loading={loading}
      onResendEmail={resendEmail}
      emailConnected={emailConnected}
      mode={mode}
      briefingTime={briefingTime}
    />
  );
}
